import * as React from 'react';
import { select} from 'd3-selection'


import { STATUS_COLORS } from '../../constants'


const MARGIN = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
}


class CalibrationTimeline extends React.PureComponent {

    constructor(props){
        super(props)
        this.WIDTH = this.props.size[0] - MARGIN.left - MARGIN.right
        this.HEIGHT = this.props.size[1] - MARGIN.top - MARGIN.bottom
    }

    componentDidMount(){
        this.createGraph()
    }

    componentDidUpdate(){
        select(this.node).selectAll("g").remove()
        this.createGraph()
    }

    createGraph = () => {

        var svg = select(this.node)
        var group = svg.append("g")
                    .attr("transform", "translate(" + MARGIN.left + "," + MARGIN.top + ")")

        if(!this.props.data || this.props.data.length < 1) {
            group.append("rect").attr("fill", STATUS_COLORS['out of operation'])
            .attr("width", this.WIDTH)
            .attr("height", this.HEIGHT)
            return;
        }

        
        const data = this.props.data[0].closed


        group.selectAll(".rects").data([data]).enter()
            .append("rect")
            .attr("fill", d => d ? STATUS_COLORS['operational'] : STATUS_COLORS['hold due to issue'])
            .attr("width", this.WIDTH)
            .attr("height", this.HEIGHT)

    }

    render(){

        

        return(
          <svg ref={node => this.node = node} 
          width={this.props.size[0]} height={this.props.size[1]} />
          )
    }
}

export default CalibrationTimeline;
 
